import React from 'react'

import AmendESignatureModal from '@/components/misc/CommercialAgreementsForm/components/AmendESignatureModal'
import { useReviewESignatureLetterModal } from '@/components/modals/ReviewESignatureLetterModal/useReviewESignatureLetterModal'
import { Button } from '@/components/ui/button'
import useDialog from '@/hooks/useDialog'

interface Props {
  onApprove?: () => void
  onAmend?: (amendRequest: string) => void
  amendRequest?: string
}

const ReviewActions: React.FC<Props> = ({
  onApprove,
  onAmend,
  amendRequest,
}) => {
  const { hideModal } = useReviewESignatureLetterModal()

  const {
    isShowingDialog: isShowingAmendDialog,
    showDialog: showAmendDialog,
    hideDialog: hideAmendDialog,
  } = useDialog()

  return (
    <>
      {(onApprove || onAmend) && (
        <section
          className="flex flex-col flex-row items-center gap-x-4 gap-y-2
            sm:flex-row sm:justify-end"
        >
          <Button
            variant="success"
            size="lg"
            className="w-full sm:order-last sm:w-auto"
            onClick={onApprove}
          >
            Approve
          </Button>

          <Button
            variant="outline-primary"
            size="lg"
            className="w-full sm:order-first sm:w-auto"
            onClick={showAmendDialog}
          >
            Amend
          </Button>
        </section>
      )}

      {onAmend && isShowingAmendDialog && (
        <AmendESignatureModal
          onSubmit={(amendRequest) => {
            onAmend(amendRequest)
            hideAmendDialog()
            hideModal()
          }}
          onClose={hideAmendDialog}
          amendRequest={amendRequest}
        />
      )}
    </>
  )
}

export default ReviewActions
